import ActionTypes from '../actionTypes';


const initialState = {
  showMenu: false,
};

const dispatch = (state = initialState, action) => {
  switch(action.type) {
    case ActionTypes.SHOW_MENU_BUTTON:
      const showMenu = action.payload.showMenu;
      return {
        showMenu: showMenu
      };
    default:
      return state
  }
};

export default dispatch;
